module.exports = __webpack_public_path__ + "img/logo.923d90b0.png";